export default __webpack_public_path__ + "static/media/Logout.fdab855d.svg";